import { TabStyles } from '@tableau/widgets';
import { divWithStyle } from '../style/LayoutComponents';
import { cssClass, Style } from '../style/StyleFunctions';

const Typography = TabStyles.Typography;
const Spacing = TabStyles.Spacing;
const Sizing = TabStyles.Sizing;

export const WarningLabelSevereBackgroundColor = '#FBF3E0';
export const WarningLabelSevereColor = '#AC4B02';

export const WarningLabelBackgroundColor = '#EAF5FE';
export const WarningLabelColor = '#05628A';

export const SensitiveLabelBackgroundColor = '#F9F0FF';
export const SensitiveLabelColor = '#9602CF';

export const CertificationLabelBackgroundColor = '#EBF7E6';
export const CertificationLabelColor = '#22683E';

export const LabelExpandoMaxWidth = 300;

export const ExpandoSectionBreakClass = cssClass('ExpandoSectionBreakClass', {
  border: '0.5px solid #CBCBCB',
  maxWidth: LabelExpandoMaxWidth
});

export const LabelPopoverWidth = 400;

export const IconColorClass = cssClass('IconColorClass', {
  color: 'inherit'
});

export const LabelIconClass = cssClass('LabelIconClass', {
  verticalAlign: 'text-bottom'
});

export const LabelIconHoverClass = cssClass('LabelIconClass', {
  verticalAlign: 'text-bottom',
  filter: 'brightness(50%)',
});

export const LabelButtonStyle: React.CSSProperties = {
  cursor: 'pointer',
  display: 'inline-flex',
  alignItems: 'center',
  height: Sizing.RowHeight,
  fontSize: Typography.Sizing.Default,
  paddingLeft: Spacing.DefaultSpace,
};

export const LabelExpandoContentDiv = divWithStyle('LabelExpandoContentDiv', {
  paddingBottom: 8
});

export const LabelAssetGroupDiv = divWithStyle('LabelAssetGroupDiv', {
  paddingLeft: 12,
  fontSize: Typography.Sizing.Default,
});

export const LabelLabelsGroupDiv = divWithStyle('LabelLabelsGroupDiv', {
  paddingLeft: 20,
});

export const LabelGroupHeadingDiv = divWithStyle('LabelGroupHeadingDiv', {
  fontWeight: 'bold',
  color: '#4F4F4F',
  marginBottom: 8,
  fontSize: Typography.Sizing.Default,
  maxWidth: LabelExpandoMaxWidth
});

export const LabelAssetChildGroupDiv = divWithStyle('LabelAssetChildGroupDiv', {
  marginLeft: -12,
  fontSize: Typography.Sizing.Default,
});

export const CertificationIconWrapperStyle = divWithStyle('CertificationIconWrapperStyle', {
  marginTop: 8,
  marginBottom: 8,
  marginRight: 4,
});

export const LabelDetailAuthorStyle = divWithStyle('LabelDetailAuthor', {
  color: Typography.Color.Secondary,
  fontSize: Typography.Sizing.Default,
  // marginTop: 8,
  // marginBottom: 8,
  textOverflow: 'ellipsis',
  whiteSpace: 'nowrap',
  overflow: 'hidden'
});

export const LabelDetailDateStyle = divWithStyle('LabelDetailDate', {
  color: Typography.Color.Secondary,
  fontSize: Typography.Sizing.Default,
  marginBottom: 8
});

export const LabelDetailMessageStyle = divWithStyle('LabelDetailMessage', {
  width: 255,
  color: Typography.Color.Primary,
  fontSize: Typography.Sizing.Default,
  $nest: {
    p: {
      marginTop: 0,
      marginBottom: 16
    }
  }
});

export const LabelDetailPermissionRequired: React.CSSProperties = {
  color: 'rgba(0,0,0,0.56)',
};

export const LabelDetailAssetStyle = divWithStyle('LabelDetailAsset', {
  fontWeight: 'bold',
  color: Typography.Color.Primary,
  fontSize: Typography.Sizing.Default,
  marginTop: Spacing.DefaultSpace,
  //marginBottom: Spacing.DefaultSpace,
  textOverflow: 'ellipsis',
  display: 'flex',
  whiteSpace: 'pre-wrap',
  overflow: 'hidden'
});


export const IconCellWrapper = divWithStyle('label-cell', {
  position: 'relative',
  left: '13.4px',
  top: '2px'
})

export const ChipCellWrapper = divWithStyle('label-cell', {
  position: 'relative',
  left: '13.4px',
  top: '2px',
  width: '200px',
  paddingRight: '10px',
})

export const HeaderLabelChipStyle = divWithStyle('header-label-chip', {
  cursor: 'pointer',
  display: 'inline-flex',
  alignItems: 'center',
  fontSize: Typography.Sizing.Default,
  paddingRight: '8px',
});

export const LabelPopoverContentStyle: React.CSSProperties = {
  padding: 0,
  marginRight: 0,
  // Set the maximum height of both the dialog and its body for IE11 compatibility.
  maxHeight: 500,
};

export const LabelPopoverStyle: Style = {
  $nest: {
    // when reference is hidden from view, hide popper
    [`&[${'data-popper-reference-hidden'}^="true"]`]: {
      display: 'none',
      pointerEvents: 'none',
    }
  }
};
